import { render, staticRenderFns } from "./sitemap.vue?vue&type=template&id=cd34de68&scoped=true"
import script from "./sitemap.vue?vue&type=script&lang=js"
export * from "./sitemap.vue?vue&type=script&lang=js"
import style0 from "./sitemap.vue?vue&type=style&index=0&id=cd34de68&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd34de68",
  null
  
)

export default component.exports